import { Component, computed, inject, input, output, signal } from '@angular/core';

import type { MenuLI, SubmenuLI } from '../../../../types/menu-li';

import { Environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../services/auth-service/auth-service';
import { StateService } from '../../../../services/state/state';
import { Submenu } from './submenu/submenu';

@Component({
  imports: [Submenu],
  selector: 'app-desktop',
  styleUrl: './desktop.css',
  templateUrl: './desktop.html',
})
export class Desktop {
  protected readonly authService = inject(AuthService);
  protected readonly stateService = inject(StateService);

  public readonly authIconClicked = output();
  public readonly menuItems = input.required<MenuLI[]>();
  public readonly temperature = input.required<number>();

  protected readonly myVillagesDropdownClass = signal('h-0 opacity-0');
  protected readonly myVillagesDropdownOpen = signal(false);
  protected readonly submenuHeight = signal('h-0');
  protected readonly submenuItems = signal<SubmenuLI[]>([]);
  protected readonly submenuOpacity = signal('opacity-0');
  protected readonly visibleMenuItems = computed(() =>
    this.menuItems().filter((i) => i.showOnDesktop),
  );

  private _submenuTimeout: ReturnType<typeof setTimeout> | undefined = undefined;

  public handleAuthClicked(): void {
    if (!this.stateService.userToken()) {
      this.stateService.handleAuthRequest();
    } else {
      //logout logic
      this.toggleMyVillagesDropdown();
    }
  }

  public hideSubmenu(): void {
    this._submenuTimeout = setTimeout(() => {
      this.submenuHeight.set('h-0');
      this.submenuOpacity.set('opacity-0');

      clearTimeout(this._submenuTimeout);

      this._submenuTimeout = undefined;
    }, 100);
  }

  public logout(): void {
    this.toggleMyVillagesDropdown(true);
    // setTimeout(() => {
    this.authService.logout();
    // }, 200);
  }

  public openMyVillages(): void {
    // if (environment.isApp){
    //   this.stateService.notifyParentOfStateChange('HF_EVENT:MY_VILLAGES_CLICKED');
    // }
    // else {
    const _origin = Environment.isApp ? 'https://www.thevillages.com' : '';
    const _url = `${_origin}/myvillages/`;

    const _newWindow = window.open(_url, '_blank');
    if (_newWindow) {
      _newWindow.opener = null; // Add this line to prevent the new window from having access to the opener's context for security reasons
    }
    // }
  }

  public showSubmenu(items?: SubmenuLI[]): void {
    if (items) {
      this.submenuItems.set(items);
    }

    if (this._submenuTimeout) {
      clearTimeout(this._submenuTimeout);

      this._submenuTimeout = undefined;
    } else {
      this.submenuHeight.set('h-16');
      this.submenuOpacity.set('opacity-100');
    }
  }

  public toggleMyVillagesDropdown(close = false): void {
    this.myVillagesDropdownOpen.set(close ? false : !this.myVillagesDropdownOpen());
    this.myVillagesDropdownClass.set(
      this.myVillagesDropdownOpen()
        ? 'h-auto opacity-100 pointer-events-auto'
        : 'h-0 opacity-0 pointer-events-none',
    );
  }
}
